export enum UserRole {
  ADMINISTRATOR = "ADMINISTRATOR", //Merchant
  EMPLOYEE = "EMPLOYEE",
}
